/**
 * Labstep
 *
 * @module components/Signature/constants
 * @desc Signature constants
 */

export enum SignatureTypeAction {
  reject = 'Reject',
  sign = 'Sign',
}
